// extracted by mini-css-extract-plugin
export default {"root":"PageHeader_root__mPYGS","container":"PageHeader_container__jm+EM","title":"PageHeader_title__FCaNJ","cover":"PageHeader_cover__aSVNu","wrapper":"PageHeader_wrapper__njmqO"};